const accessDashboard = {

    DASHBOARD: {
        path: '/dashboard'
    },

    DASHBOARDSECOND: {
        path: '/'
    },
}

export default accessDashboard;